import { render, staticRenderFns } from "./Organizationsetup.vue?vue&type=template&id=767eb8ba"
import script from "./Organizationsetup.vue?vue&type=script&lang=js"
export * from "./Organizationsetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports